import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="timeago"
export default class extends Controller {
  connect() {
    $("time.timeago").timeago();
  }
}
